<div
    class="alert"
    [ngClass]="{
        'alert-danger': type == AlertType.danger,
        'alert-primary': type == AlertType.primary
    }"
    *ngIf="show"
>
    {{ message }}

    <button [id]="'button_alert_Close'" type="button" class="close" (click)="Close()">
        <span>×</span>
    </button>
</div>
